export const SIGNING_WITH_SMS_STATUSES = {
  BEGIN_SIGNING: "BEGIN_SIGNING",
  SEND_PASSWORD: "SEND_PASSWORD",
} as const;
